/**
 * Deal-specific form state sub-hook.
 * Manages: deal percent of original deal price guardrail.
 */

import { useState, useEffect } from 'react';
import { FormMode } from 'src/components/organisms/CampaignForm/types';
import { CampaignData } from 'src/@types/valueMatching/campaign';

export interface UseDealFormStateParams {
    mode: FormMode;
    initialData?: CampaignData;
}

export function useDealFormState({ mode, initialData }: UseDealFormStateParams) {
    const [dealPercentOfOriginalDealPrice, setDealPercentOfOriginalDealPrice] = useState('');

    // ── Populate from initialData (modify / view) ───────────────────────
    useEffect(() => {
        if (mode === FormMode.CREATE || !initialData) return;

        const dealGuard = initialData.guardrails?.deal;
        if (dealGuard) {
            setDealPercentOfOriginalDealPrice(
                String(dealGuard.percentOfOriginalDealPriceGuardrail ?? ''),
            );
        }
    }, [mode, initialData]);

    return {
        dealPercentOfOriginalDealPrice,
        setDealPercentOfOriginalDealPrice,
    };
}
